import { useEffect, useState } from "react";
import api from "./api"; // Tu configuración base de Axios
import { useUserSuperEmpresa } from "../Context/AuthContext";

// ------------------------------------
// 🔹 Hook base: CRUD de egresos
// ------------------------------------
export const useEgresoCBO = () => {
  const { Token } = useUserSuperEmpresa();

  // 📌 Crear egreso
  const crearEgreso = async (nuevoEgreso) => {
    try {
      const { data } = await api.post("/expenses-cbo", nuevoEgreso, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      console.error("💥 Error al crear egreso:", error);
      throw error.response?.data?.message || "Error al crear egreso";
    }
  };

  // ✏️ Editar egreso
  const editarEgreso = async (id, egresoActualizado) => {
    try {
      const { data } = await api.put(`/expenses-cbo/${id}`, egresoActualizado, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      console.error("💥 Error al editar egreso:", error);
      throw error.response?.data?.message || "Error al editar egreso";
    }
  };

  // ❌ Eliminar egreso
  const eliminarEgreso = async (id) => {
    try {
      const { data } = await api.delete(`/expenses-cbo/${id}`, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      console.error("💥 Error al eliminar egreso:", error);
      throw error.response?.data?.message || "Error al eliminar egreso";
    }
  };

  return {
    crearEgreso,
    editarEgreso,
    eliminarEgreso,
  };
};

// ------------------------------------
// 🔹 Hook de consulta: obtener egresos
// ------------------------------------
export const useGetEgreso = () => {
  const { Token } = useUserSuperEmpresa();
  const [egresos, setEgresos] = useState([]);
  const [loadingEgresos, setLoadingEgresos] = useState(false);
  const [errorEgresos, setErrorEgresos] = useState(null);

  const fetchEgresos = async () => {
    setLoadingEgresos(true);
    try {
      const { data } = await api.get("/expenses-cbo", {
        headers: { Authorization: `Bearer ${Token}` },
      });
      setEgresos(data);
      setErrorEgresos(null);
    } catch (error) {
      console.error("💥 Error al obtener egresos:", error);
      setErrorEgresos(error.response?.data?.message || "Error al obtener egresos");
    } finally {
      setLoadingEgresos(false);
    }
  };

  // 🔁 Cargar automáticamente al montar
  useEffect(() => {
    fetchEgresos();
  }, []);

  return {
    egresos,
    loadingEgresos,
    errorEgresos,
    refetchEgresos: fetchEgresos, // para recargar manualmente
  };
};
